import { jwtDecode } from 'jwt-decode'
import { useLocalStorage } from 'usehooks-ts'

type TUserDataByDecodedToken = {
    exp: number
    iat: number
    id: number
    login: string
}

export const useGetUserByToken = () => {
    const [token] = useLocalStorage('user', '')

    if (!token) {
        return null
    }

    const user = jwtDecode(token) satisfies TUserDataByDecodedToken
    return user
}
